import React from 'react';
import {Route} from "react-router-dom";
import ProjectDashboard from "./ProjectDashboard";
import Rfis from "./Rfis/Rfis";
import Submittals from "./Submittals/Submittals";
import Tasks from "./Tasks/Tasks";
import DailyLogs from "./DailyLogs/DailyLogs";
import PunchList from "./PunchList/PunchLists";
import connect from "react-redux/es/connect/connect";
import {PathBreadcrumbItem, withBreadcrumbCurried} from "../Boilerplate/BreadcrumbContext";
import {getProject, setProjectViewed} from "../../actions/projects";
import {ProjectFiles} from "./ProjectFiles";
import {compose} from "redux";
import {Icon} from 'antd';
import ProjectContacts from "./ProjectContacts";
import {RoutedTabsFactory} from "../Boilerplate/RoutedTabs";
import {setViewPath} from "../../actions/view";
import {withLoading404} from "../Boilerplate/deferLoaderHoc";
import ProjectEdit from "./ProjectEdit";
import {canViewContacts} from "../Boilerplate/permissions";
import MeetingMinutes from "./MeetingMinutes/MeetingMinutes";

class Project extends React.PureComponent{
  getTabs = () => {
    const { project } = this.props;
    const contactsTab = {
      key: 'contacts',
      text: 'Contacts',
      icon: <Icon type='contacts'/>,
      dest: params => '/projects/' + params.id + '/contacts/',
      selected: { path: "/projects/:bidId/contacts" }
    };
    let tabs = [
      {
        key: 'dashboard',
        text: 'Dashboard',
        icon: <Icon type='dashboard'/>,
        dest: params => '/projects/' + params.id,
        selected: { path: "/projects/:id", exact: true }
      },
      {
        key: 'files',
        text: 'Files',
        icon: <Icon type='folder-open'/>,
        dest: params => '/projects/' + params.id + '/files/',
        selected: { path: "/projects/:id/files" }
      },
      {
        key: 'rfis',
        text: 'RFIs',
        icon: <Icon type='question'/>,
        dest: params => "/projects/" + params.id + "/rfis/",
        selected: { path: "/projects/:id/rfis/" }
      },
      {
        key: 'submittals',
        text: 'Submittals',
        icon: <Icon type='audit'/>,
        dest: params => "/projects/" + params.id + "/submittals/",
        selected: { path: "/projects/:id/submittals/" }
      },
      {
        key: 'tasks',
        text: 'Tasks',
        icon: <Icon type="pushpin" />,
        dest: params => "/projects/" + params.id + "/tasks/",
        selected: { path: "/projects/:id/tasks/" }
      },
      {
        key: 'dailylog',
        text: 'Daily Log',
        icon: <Icon type="schedule" />,
        dest: params => "/projects/" + params.id + "/daily-logs/",
        selected: { path: "/projects/:id/daily-logs/" }
      },
      {
        key: 'meetingminutes',
        text: 'Meeting Minutes',
        icon: <Icon type="schedule" />,
        dest: params => "/projects/" + params.id + "/meeting-minutes/",
        selected: { path: "/projects/:id/meeting-minutes/" }
      },
      {
        key: 'punchlist',
        text: 'Punch List',
        icon: <Icon type="bars" />,
        dest: params => "/projects/" + params.id + "/punch-list/",
        selected: { path: "/projects/:id/punch-list/" }
      },
    ];
    if (canViewContacts(project)) tabs.splice(1, 0, contactsTab);
    return tabs;
  };

  componentDidMount() {
    if (!this.props.project.resource.viewed) this.props.setViewed && this.props.setViewed();
  }

  render() {
    const NavBar = RoutedTabsFactory(this.getTabs(), 'dashboard', { className: 'subnav', force: true });

    return (
      <div>
        <NavBar/>
        <Route exact path="/projects/:id" component={ProjectDashboard}/>
        <Route path="/projects/:id/edit" component={ProjectEdit}/>
        <Route path="/projects/:id/files" component={ProjectFiles}/>
        <Route path="/projects/:id/contacts" component={ProjectContacts}/>
        <Route path="/projects/:id/rfis" component={Rfis}/>
        <Route path="/projects/:id/submittals" component={Submittals}/>
        <Route path="/projects/:id/tasks" component={Tasks}/>
        <Route path="/projects/:id/daily-logs" component={DailyLogs}/>
        <Route path="/projects/:id/meeting-minutes" component={MeetingMinutes}/>
        <Route path="/projects/:id/punch-list" component={PunchList}/>
      </div>
    );
  }
}

Project.propTypes = {};

const ProjectBreadcrumb = props => PathBreadcrumbItem({ path: '/projects/', resource: props.project.resource });

export default compose(
  connect(
    (state, props) => {
      const project = state.view.data[props.match.params.id];
      if (!project) return { loading: true };
      if (project.status) return { status: project.status, resource: 'project' };
      return { project };
    },
    (dispatch, props) => ({
      setViewed: () => dispatch(setProjectViewed(props.match.params.id)),
      preload: () => dispatch(getProject(props.match.params.id)),
      loader: () => dispatch(setViewPath(['projects', props.match.params.id])),
    })
  ),
  withLoading404,
  withBreadcrumbCurried(ProjectBreadcrumb),
)(Project);



// WEBPACK FOOTER //
// ./src/components/Projects/Project.js